/* Display send conversations. */
import React, { Component } from "react";
import PropTypes from "prop-types";

class Send extends Component {

    render() {
        if(!this.props.currentsenduser){
            return null;
        }
        if(this.props.sends.length === 0){
            return null;
        }
        else{

            function stripslashes(str){
                str = str.replace(/\\'/g, '\'');
                str = str.replace(/\\"/g, '"');
                str = str.replace(/\\0/g, '\0');
                str = str.replace(/\\\\/g, '\\');
                return str;
            }

            return ( <div class="chatcontainer">

            {this.props.sends.map(eachsend =>{
                /* https://magp.ie/2011/01/20/addslashes-and-stripslashes-in-javascript/ */
                if(eachsend.fromUser === eachsend.requestingUser){
                    return <div class="fromchat"><span class="chatuser">{eachsend.fromUser}</span><span class="chatdate">{eachsend.sent}</span><span class="chatmessage">{stripslashes(eachsend.message)}</span></div>;
                }
                else{
                    return <div class="tochat"><span class="chatuser">{eachsend.fromUser}</span><span class="chatdate">{eachsend.sent}</span><span class="chatmessage">{stripslashes(eachsend.message)}</span></div>;
                }
            })}
                </div>)
        }
    }

}

Send.PropTypes = {
    fromUser: PropTypes.string.isRequired,
    toUser: PropTypes.string.isRequired,
    requestingUser: PropTypes.string.isRequired,
    sentDate: PropTypes.instanceOf(Date).isRequired,
    seenDate: PropTypes.instanceOf(Date).isRequired,
    message: PropTypes.string.isRequired
}

export default Send


// WEBPACK FOOTER //
// ./src/Send.js